// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__7qTen","header":"MergedInvoice_header__3WXLs"};